export default __webpack_public_path__ + "static/media/Visual_joil_10.6c4ba974.jpg";